import { useEffect, useState } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type FragmentContext } from '../../shared/types/fragmentContext';
import { RetainedFilters } from '../enums/RetainedFilters';

const useRetainedFilters = (): RetainedFilters => {
    const { featureFlagsVariation } = useFragmentContext<FragmentContext>();
    const [retainedFilters, setRetainedFilters] = useState<RetainedFilters>(RetainedFilters.None);

    useEffect(() => {
        if (featureFlagsVariation?.plp_global_filters === 'all') {
            setRetainedFilters(RetainedFilters.All);
        } else if (featureFlagsVariation?.plp_global_filters === 'partial') {
            setRetainedFilters(RetainedFilters.Partial);
        } else {
            setRetainedFilters(RetainedFilters.None);
        }
    }, [featureFlagsVariation]);

    return retainedFilters;
};

export { useRetainedFilters };
